import { handleActions } from 'redux-actions'

const company = handleActions({
  FETCH_COMPANY_FULFILLED: (state, action) => action.payload
}, null)

export default company



// WEBPACK FOOTER //
// ./src/reducers/company.js